import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  root: {
    marginBottom: spacing(3)
  },
  header: {
    marginBottom: spacing(4)
  },
  pagination: {
    marginTop: spacing(4)
  },
  filterBar: {
    marginBottom: spacing(4)
  }
}))
